import { useRecoilValue } from 'recoil'

import { $settingsConfiguration } from './selectors'

export function useSettingsConfiguration() {
  const settingConfig = useRecoilValue($settingsConfiguration)
  return settingConfig
}
